<template>
  <div class="gallery tw_container">
    <h2>コンポーネントのプレビュー用</h2>
    <div style="margin-bottom: 15px">
      <el-button @click="handleClick">
        Props表示
        <span v-if="displayProps">OFF</span>
        <span v-else>ON</span>
          </el-button>
    </div>
    <div v-for="(component, name) in componentsMap" :key="name" class="preview">
      <h3>{{ name }}</h3>
      <!-- TwTable -->
      <div
        v-if="
          name === 'TwTable' &&
          (TestTablePattern === 'patternB' || TestTablePattern === 'patternD')
        "
      >
        <el-form :model="{ rows: getProps(name).tableData }" ref="formRef">
          <component
            :is="component"
            v-bind="getProps(name)"
            v-on="getListeners(name)"
          />
          <div class="propsPreview" v-if="displayProps">
            <h3>Props</h3>
            <div v-for="(prop, key, index) in getProps(name)" :key="index">
              <div class="propsPreviewTitle"><span>props:</span> {{ key }}</div>
              <div class="propsPreviewContent">{{ prop }}</div>
            </div>
          </div>
        </el-form>
      </div>
      <!-- TwTable以外 -->
      <div v-else-if="name ==='TwTableFilterBar'">
        <component
          :is="component"
          :model="filterForm"
          :filterChips="filterChips"
          @apply="onApply"
          @reset="onReset"
          @remove="onRemove"
        >
          <!-- フィルター用スロット（TwTableFilterBar用） -->
          <template #form="{ model }">
            <el-form-item label="ステータス">
              <el-select v-model="model.status" placeholder="選択">
                <el-option label="未対応" value="未対応" />
                <el-option label="完了" value="完了" />
              </el-select>
              </el-form-item>
              <el-form-item label="取引名">
              <el-input v-model="model.owner" />
            </el-form-item>
          </template>
        </component>
      </div>
      <div v-else>
        <component
          :is="component"
          v-bind="getProps(name)"
          v-on="getListeners(name)"
        />
        <div class="propsPreview" v-if="displayProps">
          <h3>Props</h3>
          <div v-for="(prop, key, index) in getProps(name)" :key="index">
            <div class="propsPreviewTitle"><span>props:</span> {{ key }}</div>
            <div class="propsPreviewContent">{{ prop }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref, reactive, computed } from '@vue/composition-api';

import TwHeader from '@/components/vue3/TwHeader.vue';
import TwTable from '@/components/vue3/TwTable.vue';
import TwPagination from '@/components/vue3/TwPagination.vue';
import TwTableFilterBar from '@/components/vue3/TwTableFilterBar';
import TwInputNumberMax from '@/components/atoms/TwInputNumberMax';
import TwMenuButton from '@/components/vue3/TwMenuButton.vue';

import TwEntityIcon from '@/components/atoms/TwEntityIcon';
import TwStatusIcon from '@/components/atoms/TwStatusIcon';
import TwInputFormatNumberString from '@/components/atoms/TwInputFormatNumberString';

// table用のテストデータ
import { getTestTableData } from '@/testdata/TwTableData';

// tablePattern
const TestTablePattern = 'patternD';

const { tableData, cols } = getTestTableData(TestTablePattern);

export default defineComponent({
  name: 'ComponentGallery',
  setup() {
    const componentsMap = reactive({
      TwHeader,
      TwTable,
      TwPagination,
      TwTableFilterBar,
      TwMenuButton,
      TwEntityIcon,
      TwStatusIcon,
      TwInputFormatNumberString,
      TwInputNumberMax,
    });

    const displayProps = ref(true);

    const modelValueMap = reactive({
      localTableData: tableData,
      TwInputFormatNumberString: '',
    });

    const tableFormModel = reactive({
      tableData: [
        {
          email: '',
        },
        {
          email: '',
        },
      ],
    });

    const filterForm = reactive({
      status: '',
      owner: '',
    });

    const filterChips = computed(() => {
      const chips = [];
      if (filterForm.status) {
        chips.push({
          label: 'ステータス',
          value: filterForm.status,
          key: 'status',
        });
      }
      if (filterForm.owner) {
        chips.push({ label: '取引名', value: filterForm.owner, key: 'owner' });
      }
      return chips;
    });

    const getProps = name => {
      if (name === 'TwHeader') {
        return {
          userName: 'Importer1_forDevCS_Org1_PIC@tradewaltz.com',
          sectionName: 'Importer1_forDevCS_Org1_PIC',
          notificationCount: 0,
        };
      }
      if (name === 'TwTable') {
        return {
          tableData: modelValueMap['localTableData'],
          cols,
          editMode:
            TestTablePattern === 'patternB' || TestTablePattern === 'patternD'
              ? true
              : false,
          offsetY: 400,
          border: false,
        };
      }
      if (name === 'TwEntityIcon') {
        return {
          entityName: 'CONTRACT',
        };
      }
      if (name === 'TwStatusIcon') {
        return {
          statusCode: 1,
        };
      }
      if (name === 'TwPagination') {
        return {
          total: 79,
        };
      }
      if (name === 'TwInputNumberMax') {
        return {
          maxlength: 10,
        };
      }
      if (name === 'TwMenuButton') {
        return {
          label: 'Menu',
          items: [{ label: 'TSV Download', value: 'tsv-download' }],
        };
      }
      return {};
    };
    const getListeners = name => {
      if (name === 'TwTable') {
        return {
          'update-cell': data => {
            console.log('update-cell: ', data);
          },
          'update:tableData': data => {
            console.log('update-tableData: ', data);
            console.log('model: ', tableFormModel);
            modelValueMap.localTableData = data;
          },
          'sort-changed': data => {
            console.log('sorted: ', data);
          },
          'column-width-changed': data => {
            console.log('width change: ', data);
          },
        };
      }
      if (name === 'TwPagination') {
        return {
          'page-changed': data => {
            console.log('page-change: ', data);
          },
          'size-changed': data => {
            console.log('size-change: ', data);
          },
        };
      }
      if (name === 'TwInputFormatNumberString') {
        return {
          input: val => {
            console.log('input: ', val);
            modelValue[name] = val;
          },
        };
      }
      if (name === 'TwMenuButton') {
        return {
          select: action => {
            console.log('emit: ', action);
          },
        };
      }
      return {};
    };
    const handleClick = () => {
      console.log(displayProps.value);
      displayProps.value = !displayProps.value;
    };

    const onApply = () => {
      console.log('適用:', { ...filterForm });
    };
    const onReset = () => {
      filterForm.status = '';
      filterForm.owner = '';
    };
    const onRemove = key => {
      filterForm[key] = '';
    };

    return {
      componentsMap,
      tableFormModel,
      filterForm,
      filterChips,
      onApply,
      onReset,
      onRemove,
      displayProps,
      getProps,
      getListeners,
      handleClick,
      TestTablePattern,
    };
  },
});
</script>
<style scoped>
.gallery {
  padding: 20px;
  background: #fff;
}

.preview {
  margin-bottom: 40px;
  border: 1px solid #ccc;
  padding: 20px;
}
.propsPreviewTitle {
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 8px;
}

.propsPreviewTitle span {
  color: #aaa;
  font-weight: normal;
}

.propsPreviewContent {
  padding: 20px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 1px 1px 4px #ddd inset;
  margin-bottom: 16px;
  font-size: 11px;
  user-select: text;
}
</style>
